import { PodShapeLibrary } from "@/components/admin/PodShapeLibrary";

// Route path stays /dashboard/settings/pod-composition (bookmark stability);
// the page now manages the Shape library, which superseded the (Tier × Pod
// Size) composition template matrix.
export function SettingsPodCompositionPage() {
  return <PodShapeLibrary />;
}
